import type { AxiosInstance } from 'axios';
import type { AuthenticatedState } from '../utils/auth/index.js';

export interface WithId {
  _id: unknown;
}

export abstract class Cache {
  protected data: Promise<Map<string, WithId>> | undefined;

  public abstract one<V extends WithId>(key: unknown): Promise<V | undefined>;
}

export type IdSerializer = (id: unknown) => string;

export interface FetchAllCacheDefinition<V> {
  fetchAll: (axios: AxiosInstance) => Promise<V[]>;
  idSerializer: IdSerializer;
}

export interface FetchOneCacheDefinition<V> {
  fetchOne: (axios: AxiosInstance, id: string) => Promise<V | undefined>;
  idSerializer: IdSerializer;
  initializer: () => Map<string, V>;
}

export interface CacheProviderProps {
  authState: AuthenticatedState;
  // biome-ignore lint/suspicious/noExplicitAny: needed
  fetchAllCaches: Record<string, FetchAllCacheDefinition<any>>;
  // biome-ignore lint/suspicious/noExplicitAny: needed
  fetchOneCaches: Record<string, FetchOneCacheDefinition<any>>;
}

export type Caches<C extends Cache> = Record<string, C>;

export type CacheFactory<D, C> = (
  definition: D,
  authState: AuthenticatedState,
) => C;
